import { render, staticRenderFns } from "./end.vue?vue&type=template&id=971f9fa2&scoped=true&"
import script from "./end.vue?vue&type=script&lang=js&"
export * from "./end.vue?vue&type=script&lang=js&"
import style0 from "./end.vue?vue&type=style&index=0&id=971f9fa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971f9fa2",
  null
  
)

export default component.exports